import AdminPanelSettings from "@mui/icons-material/AdminPanelSettings";
import CloudUpload from "@mui/icons-material/CloudUpload";
import ManageAccounts from "@mui/icons-material/ManageAccounts";
import MonitorHeart from "@mui/icons-material/MonitorHeart";
import Sync from "@mui/icons-material/Sync";
import ToggleOn from "@mui/icons-material/ToggleOn";
import Warehouse from "@mui/icons-material/Warehouse";
import { ResourceProps } from "@refinedev/core";
import {
  ADMIN_PAGES,
  AdminAccess,
  AdminPageKey,
  allowedAdminMenuPages,
} from "../utils/adminAccess";

const ADMIN_PAGE_RESOURCES: Partial<Record<AdminPageKey, ResourceProps>> = {
  sellers: {
    name: "admin-sellers",
    list: "/admin/sellers",
    meta: { icon: <ManageAccounts /> },
  },
  "product-sync": {
    name: "admin-product-sync",
    list: "/admin/product-sync",
    meta: { icon: <Sync /> },
  },
  "listing-sync": {
    name: "admin-listing-sync",
    list: "/admin/listing-sync",
    // sending prices and stock up to Amazon, unlike the product sync's pull
    meta: { icon: <CloudUpload /> },
  },
  "feature-flags": {
    name: "feature-flags",
    list: "/admin/feature-flags",
    show: "/admin/feature-flags/:key",
    meta: { icon: <ToggleOn /> },
  },
  warehouses: {
    name: "admin-warehouses",
    list: "/admin/warehouses",
    meta: { icon: <Warehouse /> },
  },
  system: {
    name: "admin-system",
    list: "/admin/system",
    meta: { icon: <MonitorHeart /> },
  },
};

// "Admin" group shown above the seller menu for users with an admin role (see
// App). Kept separate from navigationItems so the seller menu is untouched.
// Only the pages the user's roles allow are listed (see ADMIN_PAGES); without
// any of them the group itself is left out. Each page carries its section
// (meta.adminGroup), under which AdminMenu lists it.
export const getAdminResources = (access: AdminAccess): ResourceProps[] => {
  const pages = allowedAdminMenuPages(access).flatMap((key) => {
    const resource = ADMIN_PAGE_RESOURCES[key];
    if (!resource) return [];
    return [
      {
        ...resource,
        meta: {
          ...resource.meta,
          parent: "admin",
          adminGroup: ADMIN_PAGES[key].group,
        },
      },
    ];
  });
  if (pages.length === 0) {
    return [];
  }
  return [
    {
      name: "admin",
      meta: {
        icon: <AdminPanelSettings />,
      },
    },
    ...pages,
  ];
};
